// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1M0Xy","colMin":"styles_colMin__20nBf","colCheckbox":"styles_colCheckbox__3s0UR"};